export const REQUEST_PREFERENCE_QUESTIONS_FETCH_EM =
  "REQUEST_PREFERENCE_QUESTIONS_FETCH_EM";
export const FETCH_PREFERENCE_QUESTIONS_EM_SUCCESS =
  "FETCH_PREFERENCE_QUESTIONS_EM_SUCCESS";
export const FETCH_PREFERENCE_QUESTIONS_EM_FAILURE =
  "FETCH_PREFERENCE_QUESTIONS_EM_FAILURE";
export const CLEAR_FETCH_PREFERENCE_EM_STATES =
  "CLEAR_FETCH_PREFERENCE_EM_STATES";
export const CHANGE_TO_NEXT_PREFRENCE_STATE = "CHANGE_TO_NEXT_PREFRENCE_STATE";
